<template>
<div class="detect_index">
  <div class="property_index_search" v-if="page == 1">
    <div class="property_index_search_input">
      <div style="width: 850px;">
        <el-input
          placeholder="请输入或选择查询内容"
          prefix-icon="el-icon-search"
          v-model="searchData"
          @input="inputValueChange"
          @focus="getValueMethods"
          style="border-radius:30px;">
          <!-- <el-button
            size="mini"
            style="line-height: 26px;"
            slot="suffix"
            type="text"
            @click="dialogManager = true">
          选择
          </el-button> -->
              
          <el-select v-model="selectSearchData" slot="append" placeholder="" style="border-left: 0px; width: 230px;" @change="resetForm('SForm')">
            <el-option label="根据名称查询" value="1"></el-option>
            <el-option label="根据状态查询" value="2"></el-option>
          </el-select>
        </el-input>
      </div>
      <div>
        <el-button type="text"  @click="showData()" style="font-size: 16px; color: #121212; margin-left: 24px;">查询</el-button>
        <el-button type="text"  @click="resetForm()" style="font-size: 16px; color: #121212; margin-left: 24px;">重置</el-button>
      </div>
    </div>
  </div>

  <el-dialog title="根据状态查询" :visible.sync="dialogStates" width="35%">
    <span>根据状态查询:</span>
    <el-select v-model.trim="selectStates" placeholder="根据单位查询" @change="statesChange">
      <el-option
      v-for="i in statesList"
      :label="i.label"
      :key="i.value"
      :value="i">
      </el-option>
    </el-select>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogStates = false">取 消</el-button>
      <el-button type="primary" @click="dialogStates = false;">确 定</el-button>
    </div>
  </el-dialog>
  
    <div v-if="page == 1">
        <el-container>
            <el-table
                :data="tableData"
                >
                  <el-table-column
                    prop="detectName"
                    label="清查任务名称"
                    width="180">
                  </el-table-column>

                <el-table-column
                  prop="msg"
                  label="清查任务备注">
                </el-table-column>

                <el-table-column
                  prop="predictDate"
                  label="预期完成时间">
                </el-table-column>
                <el-table-column
                  label="资产状态"
                  prop="state"
                  >
                  <template slot-scope="scope">
                    <div v-if="scope.row.state == 1" style="color: #0D67FC;">进行中</div>
                    <div v-if="scope.row.state == 2">待审核</div>
                    <div v-if="scope.row.state == 3" style="color: #0D67FC;">已完成</div>
                    <div v-if="scope.row.state == 4" style="color: #CD1515;">已驳回</div>
                    <div v-if="scope.row.state == 5" style="color: #31986F;">已终止</div>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  prop="createDate"
                  label="创建时间">
                </el-table-column>
                <el-table-column
                  prop="endDate"
                  label="结束时间">
                </el-table-column> -->


                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <!-- <el-select  v-model.trim="tableData[scope.$index].Num" placeholder="是否为资产状态">
                        <el-option label="进行中" value='1'></el-option>
                        <el-option label="待审核" value='2'></el-option>
                        <el-option label="已完成" value='3'></el-option>
                        <el-option label="已驳回" value='4'></el-option>
                        <el-option label="已终止" value='5'></el-option>
                      </el-select> -->
                      <el-button type="small" @click="ShengHe(scope.row, 3)" style="color: #0D67FC; background-color: rgba(66,133,244,0.1);">完成</el-button>
                      <el-button type="small" @click="ShengHe(scope.row, 4)" style="color: #CD1515; background-color: rgba(205,21,21,0.1);">驳回</el-button>
                      <el-button type="small" @click="ShengHe(scope.row, 5)" style="color: #31986F; background-color: rgba(68,177,134,0.1);">终止</el-button>
                      <el-button type="text" @click="handdle(scope.row)">详情</el-button>
                      <!-- <el-button type="text" @click="ShengHe(scope.row)">确定任务状态</el-button> -->
                    </template>
                </el-table-column>





              </el-table>
        </el-container>

      </div>


      <div v-if="page == 2">
        <DetectIndexDetail></DetectIndexDetail>
      </div>
    
      <el-pagination
        v-if="page == 1"  
        style="margin: 60px 60px 0 0; padding-bottom: 30px; display: flex; flex-direction: row-reverse;"      
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>

</div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import DetectIndexDetail from "./DetectIndexDetail.vue"
  export default {
     name: 'DetectIndex',
     components:{
       DetectIndexDetail
     },
    data () {
      return {
        // 用v-if来做翻页
        page:1,
        // 存入清查任务Id
        checkId:'',
        // 存入子任务Id
        taskId:'',

        pageNum: 1,
        pageSize: 10,
        state: '',
        detectName: '',
        dialogStates: false,
        total: 0,
        searchData: '',
        selectSearchData: '',
        dialogStates: false,
        statesList: [
          {label: '进行中', value: 1},
          {label: '待审核', value: 2},
          {label: '已完成', value: 3},
          {label: '已驳回', value: 4},
          {label: '已终止', value: 5},
        ],
        selectStates: '',
        // 存入清查任务数据
        tableData: [{
                del:'',
                detectId:'',
                detectName:'',
                endDate:'',
                createDate:'',
                msg:'',
                predictDate:'',
                state:'',
                unit:'',
                unitId:'',
                  Num:''
                }]
      };
    },
    mounted:function() {
      this.showData();

    },
     methods: {
			 // 切换页面同时将选中的任务数据保存下来
       handdle(row){
        // if(event.label !== '操作') {
          
        // }
        
        this.page = 2
        this.detectId = row.detectId
        // this.taskId = row.taskId
        // console.log(this.checkId, this.taskId)
       },

			// 审核清查任务功能
       ShengHe(val, state){
         var authorization = Cookies.get("Authorization");
         var params = {
           detectId: val.detectId,
           state: state,
         }
          this.axios({
              method: 'POST',
              url: '/detect/applyDetect',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((res)=>{
              if(res.data.code == 200) {
                this.$message.success('操作成功')
                this.showData();
              } else {
                this.$message.error(res.data.message)
              }
            })


       },


		// 展现清查任务单
      showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: this.pageNum,
          pageSize: this.pageSize,
          state: this.state,
          detectName: this.detectName,
        }
        this.axios({
            method: 'GET',
            url: '/detect/detectSearch',
            params:params,
            header:{
              'Authorization':authorization,
              'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            }
          }).then((resp)=>{
            this.tableData = resp.data.data;
            this.total = resp.data.count;
          })
      },

      resetForm() {
        this.state = ''
        this.detectName = ''
      },

      inputValueChange() {
        this.selectSearchData == '1' ? 
          this.detectName = this.searchData : ''
      },

      getValueMethods(){
        switch (this.selectSearchData) {
          case '2': 
            this.dialogStates = true
            break
        }
      },
      statesChange(e) {
        this.state = e.value
        this.searchData = e.label
      },

      handleCurrentChange(pageNum) {
        console.log(pageNum)
        this.pageNum = pageNum
        this.showData()
      },
    }
   }
</script>

<style lang="less">
  .detect_index {
    background: #fff;
    width: 1650px;

    .property_index_search {
      color: #7F8F9B !important;
      display: flex;
      // justify-content: space-between;
      // flex-direction: column;
      
      .property_index_search_input {
        // width: 850px;
        padding: 24px 60px;
        border-radius: 30px;
        display: flex;
        margin: 0 auto;
        flex-direction: column;

        .property_index_search_input_text {
          line-height: 45px; 
          margin-left: 24px;
          color: #121212;
          font-size: 16px;
        }
      }

      .property_index_search_button {
        margin: 24px 50px 0 0;
        display: flex;
        justify-self: start;
      }
      .el-input__inner {
        background: #F5F5F5 !important;
        border: 30px; 
        // border-radius: 30px 0 0 30px;
        color: #7F8F9B;
      } 
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/Detect/DetectIndex.vue